module.exports = __webpack_public_path__ + "static/media/BrixSans-ExtraLight.e668a041.woff";